export default {
      id: "arrow_up-usage",
      viewBox: "0 0 9 5",
      url: "/" + "images/icons.3.109.2.svg#arrow_up-usage",
      toString: function () {
        return this.url;
      }
    }